import React, {useState, useEffect} from "react";
import axios from "axios";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Card from "../../Components/Cards/Card";
import {useForm} from "react-hook-form";
import FileInput from "../../Components/Inputs/FileInput";
import swal from "sweetalert";

export default function () {

  const {handleSubmit, control, reset} = useForm({
    defaultValues: {shop_id: null, prices: null}
  });

  const [errors, setErrors] = useState({});

  const [templateLink, setTemplateLink] = useState(null);

  useEffect(() => {
    axios.post(`/product/export_urls`).then(res => {
      setTemplateLink(res?.data?.keywords);
    });
  }, []);

  const importProductKeywords = data => {
    let formData = new FormData;

    formData.append('keywords', data.keywords || '');

    axios.post('/product/import/keywords', formData).then(res => {
      swal(res.data.message, {
        icon: "success",
      });

      reset({});
      setErrors({});
    }).catch(error => {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      } else {
        swal(error.message, {
          icon: "error",
        });
      }
    });
  }

  return (
    <Card title="Import product keywords">
      {templateLink && (
        <a href={templateLink} className="btn btn-primary me-2 mb-4 mt-1 download_product_template">
          <i className="fas fa-download"></i> Products keywords template
        </a>
      )}

      <form className="form w-100 row" onSubmit={handleSubmit(importProductKeywords)}>
        <FileInput
          label="Products keywords"
          name="keywords"
          control={control}
          errorMessage={errors?.keywords}
        />

        <div className="col-12">
          <SubmitButton
            title="Import"
            classes="w-auto d-inline-block mt-3"
          />
        </div>
      </form>
    </Card>
  );
}